// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane, Sprite, Text } from 'pixi.js';
import { ButtonLargeLayout } from '../../common/buttons/ButtonLargeLayout';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: undefined,
      stateByName: {}
    },
    {
      id: '090f753b-c2aa-4162-a2eb-1293da084703',
      type: 'Layout',
      runtimeType: null,
      name: 'button',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 0,
      scale: {
        x: 0.6,
        y: 0.6
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        color: 'grey',
        tapSound: 'UI_Button_Click'
      },
      stateByName: {}
    },
    {
      id: '7a5cd71d-f061-4056-a7fd-0839c5ed51b2',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: 'shadow',
      className: '',
      x: 0,
      y: 4,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 105,
        y: 37
      },
      width: 210,
      height: 74,
      leftWidth: 70,
      topHeight: 70,
      rightWidth: 70,
      bottomHeight: 70,
      angle: 0,
      alpha: 0.1,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {},
      data: undefined
    },
    {
      id: 'd39d5832-0920-477a-878d-e810ff834564',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: 'center_SPL',
      x: -43,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock_Icon',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'fc5d7505-059b-446c-9769-818ffe44a740',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: 'center_SPL',
      x: 13,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'FREE',
      localize: true,
      maxWidth: 130,
      maxHeight: 91,
      maxFontSize: 0,
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#484848',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class DailyLockedButtonLayout {
  static raw = raw;
  root: Container;
  button: ButtonLargeLayout & { data: typeof raw['list'][1]['data'] };
  shadow: NineSlicePlane;
  center_SPL: (Sprite | Text)[];

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      button: typeof raw['list'][1];
      shadow: typeof raw['list'][2];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
